import React from 'react';
import PropTypes from 'prop-types';

import { Stack } from '@metarouter-private/mr-mui';

import { useModalContext } from 'app/pipelines/ModalContext';
import AuditLogIconButton from 'app/audit-logs/AuditLogIconButton';

import PipelineActionsKebabMenu from './PipelineActionsKebabMenu';

const STACK_PROPS = {
  alignItems: 'center',
  direction: 'row',
};

export default function ActionsCell({ row }) {
  const { openAuditLog } = useModalContext();

  return (
    <Stack {...STACK_PROPS}>
      <AuditLogIconButton onClick={() => openAuditLog(row)} />
      <PipelineActionsKebabMenu row={row} />
    </Stack>
  );
}

ActionsCell.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
